// Room identifiers are prefixed with a context keyword: 'publications/:id'
export enum ERoomTypes {
    PUBLICATIONS_ROOM = 'publications',
    JOBS = 'jobs',
    USERS = 'users'
}
